import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '@base/store';
import { markNewsletterPopupAsShown, resetNewsletterPopupState, shouldShowNewsletterPopup } from '@utils/newsletterPopup';

import NewsletterPopup from './NewsletterPopup/NewsletterPopup';

interface NewsletterPopupWrapperProps {
    children: React.ReactNode;
}

const NewsletterPopupWrapper: React.FC<NewsletterPopupWrapperProps> = ({ children }) => {
    const [showPopup, setShowPopup] = useState(false);
    const user = useSelector((state: RootState) => state.user);
    const location = useLocation();

    useEffect(() => {
        // Only show popup if user is logged in and just arrived at dashboard
        if (user && user.id && location.pathname === '/dashboard') {
            // Check if we should show the popup (based on localStorage and subscription status)
            const checkPopup = async () => {
                if (await shouldShowNewsletterPopup(user.email)) {
                    // Slight delay to let the page load first
                    const timer = setTimeout(() => {
                        setShowPopup(true);
                    }, 1000);
                    return () => clearTimeout(timer);
                }
            };
            checkPopup();
        }
    }, [user, location.pathname]);

    // Add a global method to reset the popup state (for testing)
    useEffect(() => {
        (window as any).resetNewsletterPopup = () => {
            resetNewsletterPopupState();
            console.log('Newsletter popup state has been reset. Refresh the page to see changes.');
        };
        return () => {
            delete (window as any).resetNewsletterPopup;
        };
    }, []);

    const handleHidePopup = () => {
        setShowPopup(false);
        markNewsletterPopupAsShown();
    };

    return (
        <>
            {children}
            <NewsletterPopup
                show={showPopup}
                onHide={handleHidePopup}
                userData={{
                    email: user?.email,
                    firstName: user?.firstName,
                    lastName: user?.lastName,
                }}
            />
        </>
    );
};

export default NewsletterPopupWrapper;
